var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"badge-alert-component"}},[_c('v-btn',{class:(_vm.alert.triggered && !_vm.alert.acquitted ? 'bounce-btn' : ''),attrs:{"color":_vm.alert.acquitted
                ? 'grey'
                : _vm.alert.triggered
                ? _vm.alert.configuration_appearance.color_triggered
                : _vm.alert.configuration_appearance.color_untriggered,"elevation":"0","fab":"","small":""}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" mdi-"+_vm._s(_vm.alert.triggered ? _vm.alert.configuration_appearance.icon_triggered : _vm.alert.configuration_appearance.icon_untriggered)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }